import { defineComponent as _defineComponent } from 'vue'
import { Exercise, UpdateExerciseParams } from '@ilteducation/exercise-service-types';
import { getCurrentInstance, ref } from 'vue';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoExercisesTable',
  props: {
    exercises: null
  },
  setup(__props: any) {

const props = __props as { exercises: Exercise[] }


const route = useRoute();

const exerciseHeaders = [{ text: 'Title' }, { text: 'Last Updated' }, { text: '' }];

const getEditLink = (exercise: Exercise) => {
  const currentPath = route.path;
  return {
    name: 'exercises_edit',
    params: { id: exercise.id },
    query: { returnTo: currentPath },
  };
};

const mutableExercises = ref<Exercise[]>(props.exercises);

const store = ref<any>();
const useStore = () => {
  const vm = getCurrentInstance()!.proxy;
  store.value = vm.$store;
};
useStore();

const updateExerciseOrder = () => {
  const exercisesWithUpdatedOrder = mutableExercises.value
    .filter((exercise) => exercise.type === 'quiz')
    .map((exercise, index) => ({ ...exercise, sort: index + 1 }));
  exercisesWithUpdatedOrder.forEach(async (exercise) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, lastUpdatedAt, createdAt, ...newExercise } = exercise;

    const exerciseUpdateRequest: UpdateExerciseParams = {
      ...newExercise,
    };

    await store.value.dispatch('exercises/update', {
      id: exercise.id,
      data: exerciseUpdateRequest,
    });
  });
};

return { __sfc: true,props, route, exerciseHeaders, getEditLink, mutableExercises, store, useStore, updateExerciseOrder }
}

})